import { apiRequest } from '@/common/utils/request.common'
import {
  API_BASE_URL_ACCOUNT,
  HTTP_METHOD_GET,
} from '@/common/utils/request.const'
import { normalizeDevicesHistory } from '@/common/normalize'
export const getDevicesHistory = async ({ offset = 0, limit = 30 }) => {
  try {
    const response = await apiRequest({
      url: `${API_BASE_URL_ACCOUNT}/v1/devices/history?offset=${offset}&limit=${limit}`,
      method: HTTP_METHOD_GET,
    })

    if (!response) return { data: undefined }
    response.data = normalizeDevicesHistory(response?.data)
    return response
  } catch (error) {
    return { error: error.response }
  }
}
